import { render } from "./Edit.vue?vue&type=template&id=1e38f511&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=1e38f511&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e38f511"

export default script